<template>
    <main class="layout">
        <div class="menu">
            <g-menu></g-menu>
        </div>

        <g-navbar class="navbar"  v-show="!
        []
        .includes($route.path)"></g-navbar>

        <div class="layout-conteudo">
            <router-view></router-view>
        </div>
    </main>
</template>

<script>
import LayoutLogado from './LayoutLogado.js'
export default LayoutLogado
</script>

<style scoped>
.layout{
    width: 100%;
    min-height: 100vh;
    height: fit-content; 
    background-image: url(../../assets/imgs/fundo_retangulos_baixo.svg);
    /* background-size: cover; */
    background-position-x: right;
    background-position-y: bottom;
    background-repeat: no-repeat;
    background-attachment: fixed;
    display: flex;
    flex-direction: column;
}

.layout-conteudo{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.layout-conteudo div{
    flex-grow: 1;
}

.navbar{
    display: none;
}


@media (min-width:310px) {
   
/* .menu {
    position: fixed;
    width: 100%;
    z-index: 2;
}  */
}

@media (min-width:368px) {

}

@media (min-width:600px) {

}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
    .navbar{
        display: block;
        padding: 20px 20px 5px;
    }

}

@media (min-width:1281px) { 
    
}



</style>
